import * as React from 'react';
import {Config, CustomConfig} from './types';
import CustomBuilder from './custom-view';
import LegacyBuilder from './legacy-view';

export default function Builder({config, preview = false}: {config: Config | CustomConfig; preview?: boolean}) {
    return config.mode === 'custom' ? <CustomBuilder config={config} preview={preview}/> : <LegacyBuilder config={config} preview={preview}/>;
}
